// extracted by mini-css-extract-plugin
export var backdropBlur = "_dq-0";
export var contentCard = "_dq-5";
export var frame = "_dq-2";
export var image = "_dq-4";
export var imagePane = "_dq-3";
export var modal = "_dq-1";